// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "routes" + "-legacy." + "87e072f4" + ".js";
};